var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zenify-popup-page"},[_c('ZenifyIndex',{attrs:{"showDialer":true,"isPopup":true,"phoneNumber":_vm.initialPhone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }